"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _5OZ7J4C2cjs = require('./5OZ7J4C2.cjs');


var _VRR6XSK3cjs = require('./VRR6XSK3.cjs');

// src/menubar/menubar-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function MenubarProvider(props = {}) {
  const store = _VRR6XSK3cjs.useMenubarStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _5OZ7J4C2cjs.MenubarContextProvider, { value: store, children: props.children });
}



exports.MenubarProvider = MenubarProvider;
